<template>
  <div class="layout-main">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">国家: </div>
            <ul class="item-list">
              <li @click="selectitem('country', item.val)" v-for="(item, index) in countrys" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店长: </div>
            <ul class="item-list">
              <li @click="selectitem('user_id', item.id)" v-for="(item, index) in userList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店铺: </div>
            <ul class="item-list">
              <li @click="selectitem('store_id', item.id)" v-for="(item, index) in storeList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>

          <li class="list-group-item">
            <div class="item-label">订单类型: </div>
            <ul class="item-list">
              <li @click="selectitem('type', item.value)" v-for="(item, index) in types" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">跟进人员: </div>
            <ul class="item-list">
              <li @click="selectitem('track_user_id', item.id)" v-for="(item, index) in traceUser" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">状态: </div>
            <ul class="item-list">
              <li @click="selectitem('status', item.value)" v-for="(item, index) in statuses" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                    <Select v-model="searchfield" slot="prepend" style="width: 80px">
                        <Option value="ordersn">订单号</Option>
                    </Select>
                    <Button @click="request" slot="append" icon="ios-search"></Button>
                </Input>
           
          </li>
        </ul>
      </div>
      <div class="tools">
        <Button @click="request" style="background: #1a242f" type="primary" icon="ios-refresh"></Button>&nbsp;
        <Button @click="exportList">导出</Button>&nbsp;
      </div>
      <Divider dashed />
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="products">
         
          <div v-show="index == 0" v-for="(item, index) in row.order.products" :key="index" class="product-item">
            <div class="item-image">
              <img :src="item.item_image">
            </div>
            <div class="item-wrap">
              <p style="width: 200px;" class="item-title text-cut">{{item.item_name}}</p>
              <p class="item-info">total: {{row.order.items_count}}   amount: {{row.order.order_paid_price}}</p>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="buyer_name">
          <strong>{{ row.order.buyer_username }}</strong>
        </template>
        <template slot-scope="{ row }" slot="recipient_phone">
          <strong>{{ row.order.recipient_phone }}</strong>
        </template>
        <template slot-scope="{ row }" slot="type">
          <Select @on-change="(val)=>selectType(val, row.id)" v-model="row.order_type" style="width:200px">
              <Option v-show="item.value > 0" v-for="item in types" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row }" slot="status_text">
          <Select @on-change="(val)=>selectStatus(val, row.id)" v-model="row.status" style="width:200px">
              <Option v-for="item in statuses" :value="item.value" :disabled="item.disabled" :key="item.value">{{ item.name }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row }" slot="ordersn">
          <strong>{{ row.order.ordersn }}</strong>
        </template>
        <template slot-scope="{ row }" slot="trackuser">
          <strong>
            <span v-for="user in row.users" :key="user.id">{{user.username}}<br/></span>
          </strong>
        </template>
        <template slot-scope="{ row }" slot="store">
          <strong>{{ row.store.name }}</strong>
        </template>
        <template slot-scope="{ row, index }" slot="remark">
          <Input type="text" v-model="rowEdit.editRemarks" v-if="rowEdit.editIndex === index" />
          <span v-else><font>{{row.remark}}</font></span>
        </template>
        <template slot-scope="{ row}" slot="remark_list_last">
          <span class="remark_list_last_wrap" v-html="row.remark_list_last"></span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div v-if="rowEdit.editIndex === index">
            <Button @click="handleSave(index)">保存</Button>
            <Button @click="rowEdit.editIndex = -1">取消</Button>
          </div>
          <div v-else>
            <Icon style="cursor: pointer;" size="20" title="备注" @click="handleEdit(row, index)" type="md-create" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="备注" @click="showAddRemarkModal(row.id)" type="md-chatbubbles" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="跟进" @click="showTrackUserModal(row)" type="md-contacts" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="客户资料" @click="buyer_info(row)" type="ios-copy" />
            <Icon style="cursor: pointer;" size="20" title="操作记录" @click="operateLog(row)" type="ios-paper" />
          </div>
        </template>
      </Table>
      <div class="page-wrap">            
        <Page :current="curPage" :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
<Modal
    v-model="trackUserModal"
    title="选择跟进用户"
    @on-ok="setTrackUser"
    @on-cancel="trackUserModal = false">
    <Select multiple v-model="track_user_id" style="width:200px">
        <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.username }}</Option>
    </Select>
</Modal>
<Modal
    v-model="addRemarkModal"
    title="备注"
    :footer-hide="true"
    @on-ok="setTrackUser"
    @on-cancel="addRemarkModal = false">

 <div>
   <div class="remark-trace">
     <Timeline>
         <TimelineItem v-for="(item, index) in remarkList" :key="index">
          <div style="position: relative;">              
            <span style="display: inline-block;position: absolute;left: -150px;">{{item.create_time_text}}</span>
            <p class="content"><pre style="max-width: 300px;" @click="triggerClick" class="context-wrap" v-html="item.remark"></pre></p>
            <p class="content"><span style="font-size: 10px;" v-if="item.user">跟进人: {{item.user.username}}</span></p>
          </div>

         </TimelineItem>
     </Timeline>
   </div>
   <Divider />
   <div>
      <Form :model="remarkFormItem" :label-width="80">
       <FormItem label="备注">
           
           <EditorTool toref="remarktrackEditor" ref="editorToolElem"></EditorTool>
       </FormItem>
       <FormItem>
           <Button @click="addRemark()" type="primary">添加</Button>
       </FormItem>
     </Form>
   </div>
 </div>
</Modal>

<Modal
    v-model="preview.previewModal"
    :footer-hide="true"
    width="600"
    >
  <img style="max-width: 500px;" :src="preview.previewImgurl">
</Modal>

<Modal
    v-model="operateLogModal"
    :footer-hide="true"
    width="800"
    >
  <OperateLog ref="operateLogElem"></OperateLog>
</Modal>

</div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";
import EditorTool from '@/views/components/editor-tool';
import OperateLog from '@/views/saleser/components/operateLog.vue';

const { downloadFile, getNewline } = require("@/utils/ChatUtils");
// import Vue from 'vue';


export default {
  components: {
    EditorTool,
    OperateLog
  },

  data() {
    return {
      preview: {
        previewModal: false,      
        previewImgurl: '',
      },
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'ordersn',
      searchval: '',
      trackUserModal: false,
      addRemarkModal: false,
      operateLogModal: false,
      remarkList: [],
      storeList: [],
      selectData: {},
      track_user_id: [],
      userList: [],
      traceUser: [],
      rowEdit: {
        editIndex: -1,  // 当前聚焦的输入框的行数
        editRemarks: ''
      },
      filter: {
        connector: 'lazada',
        store_id: 0,
        type: 0,
        track_user_id: 0,
        status: 0
      },
      types: [
        {name: '全部', value: 0, active: true},
        {name: '常规', value: 1, active: false},
        {name: '退款', value: 2, active: false},
        {name: '紧急', value: 3, active: false},
        {name: '补发', value: 4, active: false},
        {name: '私下退换', value: 5, active: false},
      ],
      statuses: [
        {name: '全部', value: '', active: false, disabled: false},
        {name: '待处理', value: 0, active: true, disabled: false},
        {name: '已完成', value: 1, active: false, disabled: false},
        {name: '历史问题', value: 2, active: false, disabled: false},
      ],
      remarkFormItem: {
        aftersale_id: '',
        remark: ''
      },
      columns: [
          {
              title: '订单号',
              slot: 'ordersn',
              width: 170,
          },
          {
              title: '商品信息',
              slot: 'products',
              width: 250,
          },
          {
              title: '买家昵称',
              slot: 'buyer_name',
              width: 120
          },
          {
              title: '买家电话',
              slot: 'recipient_phone',
              width: 150
          },
          {
              title: '店铺',
              slot: 'store',
              width: 120
          },
          {
              title: '跟进人员',
              slot: 'trackuser',
              width: 120
          },
          {
              title: '订单状态',
              slot: 'type',
              width: 120
          },
          {
              title: '状态',
              slot: 'status_text',
              width: 120
          },
          {
              title: '创建时间',
              key: 'short_time_text',
              width: 120
          },
          {
              title: '备注',
              slot: 'remark',
              width: 200
          },
          {
              title: '追加备注',
              slot: 'remark_list_last',
              width: 200
          },
          {
              title: '操作',
              slot: 'action',
              fixed: 'right',
              width: 150,
              align: 'center'
          }
      ],
      // 富文本编辑器啊配置
      editorOption: {
        modules: {
          toolbar: [
            [{size: []}],
            ['image']
          ]
        }
      },
      data: [
        
      ]
    }
  },
  computed: {
    countrys: {
      get: function() {
        return conf.countrys;
      }
    },
    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    }
  },
  methods: {
    // 店铺列表
    getStoreList () {
      let self = this;
      let param = new FormData();
      param.set("connector", this.filter.connector);
      if (this.filter.country) {
        param.set("country", this.filter.country);
      }
      if (this.filter.user_id) {
        param.set("ids", this.filter.user_id);
      }
      RequestUtils.request(conf.getStoreByUid(), param)
      .then(function (data) {
        self.storeList = data
        self.storeList.unshift({
          'id': 0,
          'name': '全部',
          'active': true
        })
      })
    },
    getUserList () {
      this.userList = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.userList.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    getTraceUser () {
      this.traceUser = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.traceUser.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    // 行编辑
    handleEdit (row, index) {
      this.rowEdit.editRemarks = row.remark;
      this.rowEdit.editIndex = index;
    },
    // 行编辑保存
    handleSave (index) {
      let param = new FormData();
      param.set("id", this.data[index].id );
      param.set("remark", this.rowEdit.editRemarks );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.getHostUrl()+'/aftersale/updateRemark', param)
      .then(() => {                  
        this.data[index].remark = this.rowEdit.editRemarks;
        console.log(this.data[index]);
        this.rowEdit.editIndex = -1;
      })
    },
    // 打开会话
    openSession(row) {
      this.$store.commit(this.filter.connector+"/openSession", {
        buyer_id: row.order.buyer_id,
        store_id: row.order.store_id
      });
    },
    buyer_info (item) {
      let skus = new Array();
      for (let i=0; i<item.order.products.length; i++) {
        skus.push(item.order.products[i].item_sku);
      }
      let copyValue = item.order.recipient_info_app.recipient_addr+'\n';
      copyValue += item.order.recipient_info_app.recipient+'\n';
      copyValue += item.order.recipient_info_app.recipient_phone+'\n';
      copyValue += item.order.ordersn+'\n';
      copyValue += item.order.created_at+'\n';
      copyValue += item.store.name+'\n';
      copyValue += skus.join(',');
      
      this.$copyText(copyValue).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    addRemark() {
      let param = new FormData();
      let content = this.$refs.editorToolElem.getEditorContent();
      if (!content) {
        return this.$Message.error('内容不能为空');
      }
      param.set("connector", this.filter.connector );
      param.set("aftersale_id", this.remarkFormItem.aftersale_id );
      param.set("remark", content);
      RequestUtils.request(conf.addRemark(), param)
      .then(() => {            
        this.$refs.editorToolElem.clearContent();
        this.showAddRemarkModal(this.remarkFormItem.aftersale_id);    
        this.remarkFormItem.remark = '';
      })
    },
    showAddRemarkModal(aftersale_id) {
      let self = this;
      this.addRemarkModal = true;
      let param = new FormData();
      param.set("connector", this.filter.connector );
      param.set("aftersale_id", aftersale_id );
      RequestUtils.request(conf.getRemarks(), param)
      .then((json) => {            
        for (let i=0; i<json.length; i++)
        {
          json[i].remark = getNewline(json[i].remark.replace(/<[^>]+>/g,""), 30);
          console.log(json[i].remark);
        }
        self.remarkList = json;
        self.remarkFormItem.aftersale_id = aftersale_id;
      })
    },
    setTrackUser() {
      let self = this;
      let param = new FormData();
      param.set("id", this.selectData.id );
      param.set("track_user_id", this.track_user_id.join(',') );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.setTrackUser(), param)
      .then(() => {            
        self.$Message.success('设置成功!');
        self.request();
      })
    },
    showTrackUserModal(data) {
      this.selectData = data;
      this.trackUserModal = true;
      let selectTrackuser = new Array();
      if (data.users) {
        for (let i=0; i<data.users.length; i++) {
          selectTrackuser.push(data.users[i].id);
        }
      }
      this.track_user_id = selectTrackuser;
    },
    setStatus(data) {
      if (data.status == 1) return false;
      let self = this;
      this.$Modal.confirm({
          title: '处理售后',
          content: '<p>确定将该订单设置为已解决吗?</p>',
          onOk: () => {

            let param = new FormData();
            param.set("id", data.id );
            param.set("connector", self.filter.connector );
            param.set("status", 1 );
            RequestUtils.request(conf.aftersaleStatus(), param)
            .then(() => {            
                this.$Message.info('操作成功!');
                self.request();
            })
          },
          onCancel: () => {
          }
      });
    },
    selectitem (key, value) {
      if (key == 'store_id') {
        for (let i=0; i<this.storeList.length; i++) {
          if (this.storeList[i].id == value) {
            this.storeList[i].active = true;
          } else {
            this.storeList[i].active = false;            
          }
        }
      } else if (key == 'type') {
        let actives = new Array();
        for (let i=0; i<this.types.length; i++) {
          if (value == 0) {
            this.types[i].active = false;
          } else {
            if (this.types[i].value == value) {
              let isActive = typeof this.types[i].active == 'undefined' ? false : this.types[i].active;
              this.types[i].active = !isActive;
            }
            if (this.types[i].active) {
              actives.push(this.types[i].value);
            }
          }
        }
        this.types[0].active = (actives.length == 0 ? true : false);
        value = actives.join(',');
      } else if (key == 'track_user_id') {
        for (let i=0; i<this.traceUser.length; i++) {
          if (this.traceUser[i].id == value) {
            this.traceUser[i].active = true;
          } else {
            this.traceUser[i].active = false;
          }
        }
      } else if (key == 'user_id') {
        for (let i=0; i<this.userList.length; i++) {
          if (this.userList[i].id == value) {
            this.userList[i].active = true;
          } else {
            this.userList[i].active = false;
          }
        }
        this.filter[key] = value;
        this.getStoreList();
      } else if (key == 'status') {
        for (let i=0; i<this.statuses.length; i++) {
          if (this.statuses[i].value === value) {
            this.statuses[i].active = true;
          } else {
            this.statuses[i].active = false;
          }
        }
      } else if (key == 'country') {
        for (let i=0; i<this.countrys.length; i++) {
          if (this.countrys[i].val === value) {
            this.countrys[i].active = true;
          } else {
            this.countrys[i].active = false;
          }
        }
        this.filter[key] = value;
        this.getStoreList();
      } else if (key == 'connector') {
        this.filter[key] = value;
        this.getStoreList();
      }
      this.filter[key] = value;
      this.request();
    },
    selectType(value, id) {
      let self = this;
      let param = new FormData();
      param.set("id", id );
      param.set('type', value );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
        self.request();
      })
    },
    selectStatus(value, id) {
      let self = this;
      let param = new FormData();
      param.set("id", id );
      param.set('status', value );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
        self.request();
      })
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    // 导出表格
    exportList() {
      this.request('export');
    },
    request (type) {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("connector", this.filter.connector );
      param.set('status', this.filter.status);
      console.log(this.filter)

      if (this.filter.store_id) {      
        param.set("store_id", this.filter.store_id );
      }
      if (this.filter.type) {
        param.set('type', this.filter.type);
      }
      if (this.filter.track_user_id) {
        param.set('track_user_id', this.filter.track_user_id);
      }
      if (this.filter.country) {
        param.set('country', this.filter.country);
      }
      if (this.filter.user_id) {
        param.set('user_id', this.filter.user_id);
      }
      if (this.searchval) {
        param.set(this.searchfield, this.searchval);
      }
      if (type == 'export') {
        param.set('action', 'export');
      }

      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getAftersaleList(), param)
      .then(data => {
        if (type == 'export') {
          downloadFile(data.url);
        } else {        
          self.total = data.total;
          self.data = data.data;
        }
        self.loading = false;
      })
    },
    // 操作记录
    operateLog(row) {
      this.operateLogModal = true;
      this.$refs.operateLogElem.filter.connector = this.filter.connector;
      this.$refs.operateLogElem.filter.aftersale_id = row.id;
      this.$refs.operateLogElem.request();
    },
    triggerClick(event) {
      if (event.target.nodeName == 'IMG') {
        this.preview.previewModal = true;
        this.preview.previewImgurl = event.target.src;
      }
    }
  },

  created() {
    this.getStoreList()
    this.getUserList()
    this.getTraceUser()
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";
.remark_list_last_wrap img {
  max-width: 100px;
}
.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.product-item {
  display:flex;
  padding: 5px 0px;

  .item-image {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .item-wrap {
    padding-left: 10px;

    .item-title {
      max-width: 150px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap; 
      font-weight:bold;
    }
  }
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;
      flex: 1;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }
}

.remark-trace {
  display: flex;
  padding-left: 150px;
  height: 400px;
  overflow: scroll;

  .date-line {
    list-style: none;
    margin-right: 1rem;

    .date-item {
      height: 100px;
      width: 111px;
    }
  }
}
.ivu-table-tbody {
  .ivu-table-row:last-child {
    height: 400px;
  }
}
</style>
